<template>
  <ut-form :label-width="300">
    <ut-input placeholder="请输入报警策略名称！" v-show="false" v-model="id" readonly :style="{width:'500px'}"></ut-input>
    <ut-form-item>
      <template slot="label">
        <span style="color:red">*</span> 报警策略名称
      </template>
      <ut-input placeholder="请输入报警策略名称！" v-model="name" :style="{width:'500px'}"></ut-input>
    </ut-form-item>
    <ut-form-item>
      <template slot="label">
        <span style="color:red">*</span> 报警方式
      </template>
      <ut-checkbox-group v-model="muti">
        <ut-checkbox
          @change.native="openDialog(item)"
          :value="item"
          type="primary"
          v-for="(item, index) in type"
          :key="`checkbox-${index}`" style="display: block;"
        >{{item}} <ut-tag v-if="muti.indexOf('微信')!==-1 &&item=='微信'">{{ selectTag }}</ut-tag></ut-checkbox>
      </ut-checkbox-group>
    </ut-form-item>
    <ut-form-item>
      <template slot="label">
        <span style="color:red">*</span> 10分钟内最大报警次数：
      </template>
      <ut-input-number
        v-model="maxTimesTenMinutes"
        :min="1"
        label="请输入报警策略名称！"
        @blur="handleInputMinutes" :style="{width:'80px'}"
      ></ut-input-number>
    </ut-form-item>

    <ut-form-item>
      <template slot="label">
        <span style="color:red">*</span> 1小时内最大报警次数：
      </template>

      <ut-input-number
        v-model="maxTimesOneHour"
        :min="1"
        label="请输入报警策略名称！"
        @blur="handleInputHour" :style="{width:'80px'}"
      ></ut-input-number>
    </ut-form-item>

    <ut-form-item>
      <template slot="label">
        <span style="color:red">*</span> 1天内最大报警次数：
      </template>
      <ut-input-number :style="{width:'80px'}" v-model="maxTimesOneDay" :min="1" label="请输入报警策略名称！" @blur="handleInputDay"></ut-input-number>
    </ut-form-item>
    <ut-form-item>
      <ut-button type="primary" @click="submit">立即创建</ut-button>
      <ut-button @click="goBack">取消</ut-button>
    </ut-form-item>
    <ut-modal v-model="second" title="选择微信报警器" :modal="false" style="height:300px">
      <div slot="footer" style="height:100px">
        <ut-select v-model="selected2" filterable >
          <ut-option v-for="item in policyOptions" :value="item.id" :key="item.id" :label="item.name"></ut-option>
        </ut-select>
      </div>
      <div slot="footer" style="height:200px">
        <ut-button type="success" @click.native="second=false">确认</ut-button>
      </div>
    </ut-modal>
  </ut-form>
</template>

<script lang="babel">
export default {
  data () {
    return {
      muti: [],
      type: ['微信', '短信', '邮件', '语音'],
      name: '',
      maxTimesOneDay: '',
      maxTimesOneHour: '',
      maxTimesTenMinutes: '',
      second: false,
      policyOptions: [],
      selected2: {},
      id: '',
      corpid: '',
      corpsecret: '',
      agentId: '',
      configName: ''
    }
  },
  methods: {
    submit () {
      console.log('微信选择id  【' + this.selected2 + '】')
      if (this.muti.includes('微信')) {
        if (this.selected2 == '') {
          this.$message.error('请选择微信报警器!')
        } else {
          this.$http({
            method: 'post',
            url: 'wechat/' + this.selected2 + '/get.htm',
            data: '{}'
          })
            .then(response => {
              // 这里使用了ES6的语法
              console.log('微信参数获取 : ' + response) // 请求成功返回的数据
              this.corpid = response.data.corpid
              this.corpsecret = response.data.corpsecret
              this.agentId = response.data.agentId
              console.log('微信参数获取 agentId [' + this.agentId + '] corpid [' + this.corpid + '] corpsecret [' + this.corpsecret + ']')
              this.updateData()
            })
            .catch(error => {
              console.log(error) // 请求失败返回的数据
            })
        }
      } else {
        this.updateData()
      }
    },
    updateData () {
      var name = this.name
      var maxTimesTenMinutes = this.maxTimesTenMinutes
      var maxTimesOneHour = this.maxTimesOneHour
      var maxTimesOneDay = this.maxTimesOneDay

      var mailMark = false
      var messageMark = false
      var wechatMark = false
      var isCheck = false

      if (name == '') {
        this.$message.error('请输入报警策略名称!')
        return false
      }
      if (this.muti.includes('微信')) {
        wechatMark = true
        isCheck = true
      }
      if (this.muti.includes('邮件')) {
        mailMark = true
        isCheck = true
      }
      if (this.muti.includes('短信')) {
        messageMark = true
        isCheck = true
      }
      if (!isCheck) {
        this.$message.error('请您勾选报警器!')
        return false
      }
      var sendData = {}
      sendData.name = name
      sendData.mailMark = mailMark
      sendData.messageMark = messageMark
      sendData.wechatMark = wechatMark
      sendData.maxTimesTenMinutes = maxTimesTenMinutes
      sendData.maxTimesOneHour = maxTimesOneHour
      sendData.maxTimesOneDay = maxTimesOneDay
      sendData.id = this.id
      if (this.muti.includes('微信')) {
        sendData.corpid = this.corpid
        sendData.corpsecret = this.corpsecret
        sendData.agentId = this.agentId
      }

      this.$http({
        method: 'post',
        url: 'policys/add.htm',
        data: JSON.stringify(sendData)
      }).then(response => {
        // 这里使用了ES6的语法
        console.log(response) // 请求成功返回的数据
        if (response.data.code == 0) {
          this.$message.success('更新成功')
          this.$router.push({ path: '/policys' })
        } else {
          this.$message.error(response.data.message)
          return false
        }
      }).catch(error => {
        console.log(error) // 请求失败返回的数据
      })
    },
    goBack () {
      this.$router.push({ path: '/policys' })
    },
    openDialog (value) {
      console.log('openDialog : ' + this.selected2)
      if (this.muti.includes('微信') && value == '微信') {
        this.second = true
      }
    },
    handleInputMinutes () {

    },
    handleInputHour (e) {

    },
    handleInputDay (e) {

    }
  },
  computed: {
    selectTag () {
      for (let val of this.policyOptions) {
        if (val.id === this.selected2) {
          return val.name
        }
      }
      return ''
    }
  },
  created () {
    console.log(this.$route)
    this.$http({
      method: 'post',
      url: 'wechat/queryList.htm',
      data: '{}'
    })
      .then(response => {
        // 这里使用了ES6的语法
        console.log(response) // 请求成功返回的数据
        this.policyOptions = response.data
      })
      .catch(error => {
        console.log(error) // 请求失败返回的数据
      })

    this.$http({
      method: 'post',
      url: 'policys/' + this.$route.query.id + '/get.htm',
      data: '{}'
    })
      .then(response => {
        // 这里使用了ES6的语法
        console.log('policys ' + response.data) // 请求成功返回的数据
        this.id = response.data.id
        this.name = response.data.name
        this.maxTimesTenMinutes = response.data.maxTimesTenMinutes
        this.maxTimesOneHour = response.data.maxTimesOneHour
        this.maxTimesOneDay = response.data.maxTimesOneDay
        this.mailMark = response.data.mailMark
        this.messageMark = response.data.messageMark
        this.wechatMark = response.data.wechatMark
        this.isCheck = response.data.isCheck
        this.corpid = response.data.corpid
        this.corpsecret = response.data.corpsecret
        this.agentId = response.data.agentId

        var temp = []
        var index = 0
        if (this.messageMark == true) {
          temp[index] = '短信'
          index++
        }
        if (this.mailMark == true) {
          temp[index] = '邮件'
          index++
        }
        if (this.wechatMark == true) {
          temp[index] = '微信'
          index++
        }
        this.configName = response.data.weConfigName
        if (response.data.weConfigId != undefined) {
          this.selected2 = +response.data.weConfigId
        }

        this.muti = temp
        console.log(this.muti)
      })
      .catch(error => {
        console.log(error) // 请求失败返回的数据
      })
  }
}
</script>
